import { render, staticRenderFns } from "./wtMultirange.component.vue?vue&type=template&id=a3910b28&"
import script from "./wtMultirange.component.vue?vue&type=script&lang=js&"
export * from "./wtMultirange.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports